import UnavailableToolWarningView from './unavailableToolWarningView.html';
import * as styles from './unavailableToolWarning.module.scss';
class UnavailableToolWarningController {
    constructor() {
        this.styles = styles;
    }
}
export const UnavailableToolWarningComponent = {
    template: UnavailableToolWarningView,
    controller: UnavailableToolWarningController,
    controllerAs: '$ctrl',
};
